import styled from 'styled-components';

//helpers
import {transparentize} from 'utils/color-utils';
import {commonPalette} from 'styles/palette';

//styled-components
import {Error} from 'styles/styled-components/field-styled-components';

export const StyledInput = styled.input`
  background: none;
  border-color: ${transparentize(commonPalette.btnGreen, 0.5)};
  border-style: solid;
  border-width: 0 0 1px;
  color: ${commonPalette.txboxValue};
  display: block;
  font: inherit;
  max-width: 100%;
  outline: 0;
  padding: 0;

  &:invalid {
    border-color: ${transparentize(commonPalette.red, 0.5)};
  }

  &::placeholder {
    color: ${commonPalette.txboxPlaceholder};
  }

  + ${() => Error} {
    height: 20px;
    margin: 0;
    padding-top: 4px;
    white-space: nowrap;
  }
`;
